import { useSelector, useDispatch } from "react-redux";
import {  
  loadObject,
} from "../../redux/objectPlacement";
import { createGeometry,  } from "./utils";

import { colors } from "../../utils/colors";
import { useGetObjectPlacementData, useActiveElements } from "../CustomHooks";

const PlacedObjects = () => {
  const dispatch = useDispatch();

  const { placedObjects } = useGetObjectPlacementData();
  const editingObjectId = useSelector(
    (state) => state.objectPlacement.editingObjectId
  );

  const { objectPlacementClick } = useActiveElements();

  return placedObjects
    ?.filter((object) => object.id !== editingObjectId)
    ?.map((object) => (
      <mesh
        key={object.id}
        position={object.position}
        rotation={object.rotation}
        scale={object.scale}
        onClick={(e) => {
          e.stopPropagation();
          if (!objectPlacementClick) return;
          dispatch(loadObject({ object }));
        }}
      >
        {createGeometry(object.shape, object.params)}
        <meshStandardMaterial color={colors.white()} />
      </mesh>
    ));
};

export default PlacedObjects;
